import{getDefaultExportFromCjs as r}from"../../../_virtual/_commonjsHelpers.js";import{s}from"./stringify.js";import{p as o}from"./parse.js";import{f as m}from"./formats.js";var a=r({formats:m,parse:o,stringify:s});export{a as default};
//# sourceMappingURL=index.js.map
